export enum BadgeType {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  OUTLINE = "outline",
  DESTRUCTIVE = "destructive",
  PURPLE = "purple",
}
